// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class CitationController {
   $scope: any
   alerts: any
   citation: any
   citationValues: any
   config: any
   retryEmail: any
   translationService: any
   emailService:any
   constructor($scope: any, citation: any, alerts: any, translationService: any, citationValues: any, config: any, emailService: EmailService) {
      this.prepareDocumentsToExport = this.prepareDocumentsToExport.bind(this)
      this.markBusy = this.markBusy.bind(this)
      this.markDone = this.markDone.bind(this)
      this.clearCitation = this.clearCitation.bind(this)
      this.toggle = this.toggle.bind(this)
      this.retryCite = this.retryCite.bind(this)
      this.cite = this.cite.bind(this)
      this.email = this.email.bind(this)
      this.emailClear = this.emailClear.bind(this)
      this.emailSuccess = this.emailSuccess.bind(this)
      this.emailError = this.emailError.bind(this)
      this.isFormInvalid = this.isFormInvalid.bind(this)
      this.print = this.print.bind(this)
      this.$scope = $scope
      this.citation = citation
      this.alerts = alerts
      this.translationService = translationService
      this.citationValues = citationValues
      this.emailService = emailService
      this.config = config
      this.$scope.busy      = false
      this.$scope.citations = []
      if (this.$scope.view == null) { this.$scope.view = 'cite' }
      this.$scope.emailHtml = true
      this.$scope.isSending = false
      this.$scope.i18n = this.translationService
      this.$scope.isSenderEnabled = this.config.data.citation.enable_sender_email_citation
      this.$scope.isSenderRequired = this.$scope.isSenderEnabled && this.config.data.citation.require_sender_email_citation
      this.$scope.isFormInvalid = this.isFormInvalid
      this.$scope.recaptchaIsValid = false

      this.citationValues.options = {
         styles:         this.citation.styles,
         style:          this.citation.styles.citation[0].name,
         lastStyle:      'summon',
         format:         this.citation.styles.export[0].name,
         cite:           this.cite,
         retryCite:      this.retryCite,
         email:          this.email,
         retryEmail:     this.retryEmail,
         print:          this.print,
         toggleEmail:    this.toggle
      }

      this.$scope.citationValues = this.citationValues

      this.$scope.normalize = this.citation.normalize
      this.$scope.recipient = ""
      this.$scope.message   = ""
      this.$scope.sender   = ""
      this.$scope.translationParams = {}

      // pull in functions from parent scope
      this.$scope.openDetailPage = this.$scope.$parent.openDetailPage
      this.$scope.openClickTrackLink = this.$scope.$parent.openClickTrackLink
      this.$scope.fieldSearch = this.$scope.$parent.fieldSearch

      // add citation options to applicationController scope (for saved items dialog options in 1-col mode)
      // if this instance of the Citation Controller is for the savedItems dialog;
      // the Citation Controller is also instantiated for single doc views (i.e. document detail)
      if (this.$scope.citationSource === 'SavedItems') {
         this.prepareDocumentsToExport()
         // update href value whenever docs are added/removed from saved items
         this.$scope.$watch('documents', this.prepareDocumentsToExport, true)
      } else {
      // create a sidebar export options object so that sidebar export options do not overwrite export options for saved items
         const options = (this.$scope.sidebarExportOptions = angular.copy(this.$scope.citationValues.options.styles.export))
         this.citation.prepCitationExportOptions(this.$scope.documents, options)
      }

      this.$scope.$on('$destroy',() => {
         this.alerts.resetAlert('citationError')
         return this.alerts.resetAlert('citationEmailError')
      })

      // Listen for the event emitted by the reCAPTCHA directive
      this.$scope.$on('recaptchaValidated', (event: any, isValid: boolean) => {
         console.log("Angular received recaptchaValidated!", { isValid })
         this.$scope.recaptchaIsValid = isValid
          // Force digest if needed
         if (!this.$scope.$$phase) {
            this.$scope.$applyAsync()
         }
      })

      // Make sender input mandatory according to user config 
      if (this.$scope.isSenderRequired) { 
         const input = document.getElementById('sender')
         input?.setAttribute('required', '')
      }
   }
   prepareDocumentsToExport() {
      const {
         options
      } = this.citationValues
      return this.citation.prepCitationExportOptions(this.$scope.documents, options.styles.export)
   }

   markBusy() {
      return this.$scope.busy = true
   }

   markDone() {
      return this.$scope.busy = false
   }

   clearCitation() {
      this.$scope.citationValues.options.style = 'summon'
      return this.$scope.citationValues.options.citation = null
   }

   toggle(homeView: any) {
      const {
         view
      } = this.$scope

      if (view === homeView) {
         return this.$scope.view = 'email'
      } else {
         return this.$scope.view = homeView
      }
   }

   retryCite() {
      this.$scope.citationValues.options.style = this.$scope.citationValues.options.lastStyle
      return this.cite()
   }

   cite() {
      this.alerts.resetAlert('citationError')
      this.markBusy()
      this.$scope.citationValues.options.lastStyle = this.$scope.citationValues.options.style
      if (this.$scope.citationValues.options.style === 'summon') {
         this.markDone()
         return this.clearCitation()
      } else {
         const success = (data: any) => {
            this.markDone()
            return this.$scope.citations = data
         }
         const error = () => {
            this.alerts.setAlert('citationError', 'Citation processing error.')
            this.markDone()
            return this.clearCitation()
         }
         return this.citation.cite(this.$scope.documents, this.$scope.citationValues.options.style)
            .then(success, error)
      }
   }

   email(callback: any) {
      this.alerts.resetAlert('citationEmailError')
      this.$scope.translationParams = {}
      if (!this.$scope.isSending) {
         this.$scope.isSending = true
         const emailData = {
            documents:  this.$scope.documents,
            style:      this.$scope.citationValues.options.style,
            recipient:  this.$scope.recipient,
            message:    this.$scope.message,
            emailHtml:  this.$scope.emailHtml,
            sender:     this.$scope.sender
         }

         return this.citation
            .email(emailData)
            .then(() => {
               this.emailSuccess()
               if (angular.isFunction(callback)) { return callback() }
            })
            .catch((result: any) => (this.emailError(result)))
      }
   }

   emailClear() {
      this.emailService.clearEmailFields(this.$scope)
   }

   emailSuccess() {
      this.emailService.emailSuccess(this.$scope)
   }

   emailError(response: any) {
      this.emailService.emailError(response, 'citationEmailError', this.$scope)
   }

   print() {
      this.emailService.print()
   }

   isFormInvalid() {
      this.emailService.isFormInvalid(this.$scope.emailForm)
   }

   isEmailInvalid(type: string) {
      this.emailService.isEmailInvalid(this.$scope.emailForm, type)
   }

  
}
  

CitationController.$inject = ['$scope', 'citationService', 'alertService', 'translationService', 'citationValues', 'configService', 'emailService']

angular.module('summonApp.controllers')
   .controller('CitationCtrl', CitationController)
